import React, { useRef, useEffect, useState } from 'react';
import Image from 'next/image';
import cx from 'classnames';
import styles from './hero.module.scss';
import HeroModel from '../../models/hero';
import Richtext from '../global/richtext/Richtext';
import Link from '../global/linkButton/linkButton';
import Background from '../global/background/background';
import useBread from '../../hooks/useBread';
import AlertMessage from '../global/alert-message/AlertMessage';
import ImageWrapper from '../global/imageWrapper/imageWrapper';

export default ({
  title,
  titleLine2,
  richTextAlignLeft,
  color,
  links,
  description,
  heroImage,
  background,
  breadErrorMessage,
  svgImage,
  bikePrice
}: HeroModel) => {
  const breadWrapperRef = useRef<HTMLInputElement>(null);
  const [height, setHeight] = useState(0);
  const { breadError, hideError } = useBread(breadWrapperRef, bikePrice);

  function getStyles() {
    return {
      bottom: breadWrapperRef?.current?.getBoundingClientRect().height,
      WebkitMaskImage: 'linear-gradient(to top, transparent 2%, black 20%)'
    };
  }

  useEffect(() => {
    setHeight(window.innerHeight);
  }, []);

  const heroContent = richTextAlignLeft ? (
    <>
      {svgImage && (
        <div className={styles.hero__svgImageContainer}>
          <Image
            priority
            alt={svgImage.alt}
            height={svgImage.height}
            src={svgImage.src}
            width={svgImage.width}
          />
        </div>
      )}
      {title && (
        <div className={styles.hero__title} style={{ color }}>
          {title}
          <br />
          {titleLine2}
        </div>
      )}
      {description && (
        <Richtext
          customClasses={{
            container: styles.description__container,
            paragraph: styles.description__p
          }}
          data={description}
        />
      )}
      {!!links?.length && (
        <div className={styles.hero__links}>
          {links.map((link) => (
            <Link key={link.label} data={link} />
          ))}
        </div>
      )}
      {breadError && (
        <div className={styles.hero__error}>
          <AlertMessage
            {...breadErrorMessage}
            onClose={hideError}
            arrow="topright"
          />
        </div>
      )}
    </>
  ) : (
    <>
      {title && (
        <div className={styles.hero__title} style={{ color }}>
          {title + ((titleLine2 && ` ${titleLine2}`) || '')}
        </div>
      )}
      {!!links?.length && (
        <div className={styles.hero__links}>
          {links.map((link) => (
            <Link key={link.label} data={link} />
          ))}
        </div>
      )}
      {description && (
        <Richtext
          customClasses={{
            container: styles.description__container,
            paragraph: styles.description__p
          }}
          data={description}
        />
      )}
      {breadError && (
        <div className={styles.hero__error}>
          <AlertMessage
            {...breadErrorMessage}
            onClose={hideError}
            arrow="topright"
          />
        </div>
      )}
    </>
  );

  return (
    <section className={styles.hero} style={{ minHeight: height }}>
      <Background {...background} />
      {heroImage && <ImageWrapper {...heroImage} style={getStyles()} />}
      <div
        className={cx(styles.hero__container, {
          [styles['hero__container--align-left']]: richTextAlignLeft
        })}
        ref={breadWrapperRef}
      >
        {heroContent}
      </div>
    </section>
  );
};
